import axios from 'axios';
const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getAll(facilityId) {
		const response = await axios.get(
			`${API_URL}/api/Cms/Resources?facilityId=${facilityId}`,
			{
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			}
		);
		return response.data;
	}
	async getByID(resourceId) {
		const url = resourceId
			? `/api/Cms/Resource?id=${resourceId}`
			: '/api/Cms/Resource';

		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async update(resourceData) {
		try {
			await axios.put(`${API_URL}/api/Cms/Resource`, resourceData, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error updating simulation template:', error);
			throw error;
		}
	}
	async deleteById(resourceId) {
		try {
			await axios.delete(`${API_URL}/api/Cms/Resource?id=${resourceId}`, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
